import { redux } from 'Core/redux';
import { STORE_KEY, INITIAL_STATE } from './slice';

export const selectPart = state => {
  const appState = state || redux.store.getState();
  return appState?.[STORE_KEY] || INITIAL_STATE;
};

export const selectParts = state => selectPart(state).data;
export const selectPartLoading = state => selectPart(state).loading;
export const selectPartError = state => selectPart(state).error;
